<div class="ref-item" [class.clickable]="clickable">
  <app-ed-fit-med-profile-small
    [fitMedProfile]="referral.referringPractitionerFitMedProfile"
  ></app-ed-fit-med-profile-small>
</div>
